const SEND_AT_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

export function isSendAt(value: string): boolean {
  return SEND_AT_PATTERN.test(value);
}

export function sendAtToDate(sendAt: string): Date {
  const match = SEND_AT_PATTERN.exec(sendAt);
  return new Date(2000, 0, 1, match ? Number(match[1]) : 0, match ? Number(match[2]) : 0);
}

export function dateToSendAt(date: Date): string {
  const pad = (value: number) => value.toString().padStart(2, '0');
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
